import React from "react";

import { useBreakpoint } from "../../hooks/useBreakpoint";
import ContentCard from "../cards/contentCard";

export const ContentBlocks = ({
  title,
  blocks,
  description,
  containerClass = "pt-1",
  titleClass = "!font-light pt-6 pb-9 md:pb-14",
  contentContainerClass = "grid md:grid-cols-2 gap-8",
  descClass = ""
}) => {
  const breakpoint = useBreakpoint();

  const formattedBlocks =
    blocks?.map((cblock) => {
      return {
        title: cblock?.genCgbTitle ?? cblock?.title ?? "",
        description: cblock?.genCgbSummary ?? cblock?.description ?? "",
        imgUrl:
          breakpoint === "xs"
            ? cblock?.genCgbImageMobile?.sourceUrl ??
              cblock?.imgMobileUrl ??
              cblock?.genCgbImage?.sourceUrl ??
              cblock?.imgUrl ??
              ""
            : cblock?.genCgbImage?.sourceUrl ?? cblock?.imgUrl ?? "",
        icon: cblock?.genCgbIcon ?? cblock?.ion ?? "",
        linkTitle: cblock?.genCgbCtaTitle ?? cblock?.linkTitle ?? "",
        externalLink: cblock?.genCgbExternalLink === true,
        url: cblock?.genCgbCtaLink ?? cblock?.url ?? ""
      };
    }) ?? [];
  return (
    <div className={containerClass}>
      {title && <h1 className={titleClass}>{title}</h1>}
      {description && (
        <div
          className={descClass}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      <div className={contentContainerClass}>
        {formattedBlocks?.map((cardInfo, index) => (
          <ContentCard
            key={index}
            title={cardInfo.title}
            description={cardInfo.description}
            imgUrl={cardInfo.imgUrl}
            url={cardInfo.url}
            linkTitle={cardInfo.linkTitle}
            externalLink={cardInfo.externalLink}
            icon={cardInfo.icon}
            type={9}
          />
        ))}
      </div>
    </div>
  );
};
